export const COLORS = {
  bg: '#0a0a0f',
  surface: '#1a1a2e',
  surfaceAlt: '#22223e',
  surfaceSoft: 'rgba(20,20,30,0.9)',
  border: '#3a3a5e',
  borderSoft: 'rgba(60,60,90,0.4)',
  text: '#f0f0f0',
  textDim: '#aaaabb',
  textFaint: '#666677',
  accent: '#ffd6b3',
  accentSoft: '#ffe8cc',
  ok: '#9bff9b',
  warn: '#ffcc66',
  danger: '#ff6e6e',
  bars: {
    hunger: '#f0c870',
    happiness: '#ff6eb4',
    health: '#6cf08f',
    discipline: '#ff8844',
    weight: '#88aaff',
  },
} as const;

export const SPACING = { xs: 4, sm: 8, md: 12, lg: 16, xl: 24 } as const;
export const RADIUS = { sm: 4, md: 8, lg: 12 } as const;

export const FONT = {
  family: 'system-ui, -apple-system, "Segoe UI", sans-serif',
  mono: 'ui-monospace, "Cascadia Code", "Consolas", monospace',
  sizeXs: 10,
  sizeSm: 12,
  sizeMd: 14,
  sizeLg: 16,
  sizeXl: 20,
} as const;

export const SHADOWS = {
  card: '0 4px 12px rgba(0,0,0,0.35)',
  modal: '0 8px 32px rgba(0,0,0,0.5)',
} as const;

export const Z_INDEX = {
  splash: 1000,
  modal: 200,
  toast: 300,
  topBar: 100,
  hud: 90,
} as const;
